const azkarSafarData = {
  brand: "أذكار التنقل والسفر",
  list: [
    {
      id: 1,
      title: "أذكار السفر",
      text: [
        "الله أكبر، الله أكبر، الله أكبر.",
        "سُبْحانَ الَّذِي سَخَّرَ لَنَا هَذَا وَمَا كُنَّا لَهُ مُقْرِنِينَ * وَإِنَّا إِلَى رَبِّنَا لَمُنقَلِبُونَ",
        "اللهم إنا نسألُكَ في سفرنا هذا البرَّ والتقوى، ومن العمل ما ترضى،اللهم هون علينا سفرنا هذا واطو عنا بعده، اللهم أنت الصاحب فيالسفر، والخليفة في الأهل، اللهم إني أعوذ بك من وعْثاءِ السفر،وكآبة المنظر وسوء المنقلب في المال والأهل.",
      ],
    },
    {
      id: 2,
      title: "دعاء المقيم للمسافر",
      text: [
        "أستودعك الله دينك وأمانتك وآخر عملك وفي رواية وخواتيم عملك ، زودك الله التقوى ، وغفر ذنبك ويسر لك الخير حيث ما كنت .",
      ],
    },
    {
      id: 3,
      title: "الدعاء إن هبط مكان في سفر أو غيره",
      text: [
        "من نزل لمكان في سفره ثم قال : أعوذ بكلمات الله التامات من شر ما خلق . لم يضره شيء حتى يرحل من مكانه هذا.",
      ],
    },
    {
      id: 4,
      title: "التسبيح على الأماكن العالية والتسبيح عند النزول أو الهبوط",
      text: [
        "قال جابر رضي الله عنه:” كنا إذا صعدنا كبرنا، وإذا نزلنا سبحنا” .",
      ],
    },
    {
      id: 5,
      title: "دعاء المسلم المسافر إذا أسحر",
      text: [
        "عن أبي هريرة رضي الله عنه أن النبي صلى الله عليه وسلم كان إذا كان في سفر وأسحر يقول :سمع سامع بحمد الله وحُسنِ بلائه علينا ، ربنا صاحبنا وأفضل علينا عائذاً بالله من النار .",
      ],
    },
    {
      id: 6,
      title: "أذكار العودة من السفر",
      text: [
        "يكبر على كل شرف ثلاث تكبيرات ثم يقول: لا إله إلا الله وحده لا شريك له، له الملك، وله الحمد، وهو على كل شيء قدير، آيبون، تائبون، عابدون، لربنا حامدون، صدق الله وعده، ونصر عبده، وهزم الأحزاب وحده.",
      ],
    },
    {
      id: 7,
      title: "أدعية للسفر كاملة",
      text: [
        "اللهم هون علينا سفرنا هذا واطو عنا بعده، اللهم أنت الصاحب في السفر والخليفة في الأهل.",
        "اللهم نسألك في سفرنا هذا البر والتقوى ومن العمل ما ترضى.",
        "كان رسول الله تعالى عليه وسلم إذا سافر يتعوذ من وعثاء السفر وكآبة المنقلب والحَوْر بعد الكون ودعوة المظلوم وسوء المنظر في الأهل والمال.",
        "اللهم أنا نسألك في سفرنا هذا البر والتقوى ومن العمل ما ترضى ، اللهم هون علينا سفرنا هـذا واطوِ عنا بعده ، اللهم أنت الصاحب في السفر والخليفة في الأهل .",
      ],
    },
  ],
};

export default azkarSafarData;
